module.exports = __webpack_public_path__ + "static/game-d930637522378c8e14e8f574286dcf50.svg";